import { defineMessages } from 'react-intl-next';

export default defineMessages({
	title: {
		id: 'project-pages.improvement.errors.space-or-page-not-found.title',
		defaultMessage: 'Space or page not found',
		description:
			'Title when the Confluence space or page linked to a Jira project cannot be found due to an error',
	},
	description: {
		id: 'project-pages.improvement.errors.space-or-page-not-found.description',
		defaultMessage:
			"The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things",
		description: 'Information about potential reasons why the space or page cannot be found',
	},
	connectSpaceButton: {
		id: 'project-pages.connection-error.space-or-page-not-found.button',
		defaultMessage: 'Connect to a different space or page',
		description: 'Button to connect to a different Confluence space or page',
	},
});
